import classNames from "classnames"
import * as React from "react"

import { theme } from "@bounce/theme"
import { stringToAvatar } from "@bounce/util"

import type { PNImageProps } from "../PNImage/PNImage"
import { PNImage } from "../PNImage/PNImage"

const AVATARS_COLORS = [
  {
    color: theme.color("white"),
    backgroundColor: theme.color("cranberry-700"),
  },
  {
    color: theme.color("white"),
    backgroundColor: theme.color("orange-700"),
  },
  {
    color: theme.color("white"),
    backgroundColor: theme.color("lilac-700"),
  },
  {
    color: theme.color("cranberry-700"),
    backgroundColor: theme.color("lilac-200"),
  },
  {
    color: theme.color("cranberry-700"),
    backgroundColor: theme.color("zest-700"),
  },
  {
    color: theme.color("cranberry-700"),
    backgroundColor: theme.color("yellow-700"),
  },
]

export type AvatarProps = {
  name: string
  className?: string
  textClassName?: string
  src?: PNImageProps["src"]
  alt?: string
  loading?: "lazy" | "eager" | undefined
  backgroundColor?: string
}

export const Avatar = ({
  name,
  className,
  textClassName,
  src,
  alt = "",
  loading = "lazy",
  backgroundColor,
}: AvatarProps) => {
  const { label, color, backgroundColor: generatedBackgroundColor } = stringToAvatar({ name, colors: AVATARS_COLORS })

  return (
    // IMPROVEMENT: use tailwind css jit for the color and the backgroundColor
    <div
      className={classNames(styles.baseView, "border-[#F9EDD8]", className)}
      style={{ backgroundColor: backgroundColor ?? generatedBackgroundColor }}>
      {src ? (
        <PNImage
          src={src}
          alt={alt}
          width={36}
          height={36}
          loading={loading}
          className="size-full"
          data-chromatic="ignore"
        />
      ) : (
        <span className={classNames(styles.baseText, textClassName)} style={{ color }}>
          {label}
        </span>
      )}
    </div>
  )
}

const styles = {
  baseView:
    "border-4 !size-16 rotate-[-5.71deg] rounded-none items-center justify-center rounded-full w-9 h-9 flex shrink-0 overflow-hidden",
  baseText: "text-xl font-normal text-center",
  baseImage: "rounded-full w-full h-full",
}
